var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 342,
    viewBox: "0 0 513 342",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_722)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.0078125H513V341.996H0V-0.0078125Z",
    fill: "#00745A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.24 163.859C282.042 163.859 278.058 164.696 274.356 166.027C276.383 161.509 277.741 156.481 277.741 151.113C277.741 129.87 256.499 113.939 256.499 113.939C256.499 113.939 235.257 129.871 235.257 151.113C235.257 156.48 236.615 161.508 238.642 166.027C234.942 164.696 230.956 163.859 226.758 163.859C205.516 163.859 189.584 185.101 189.584 185.101C189.584 185.101 205.517 206.343 226.758 206.343C239.211 206.343 249.834 199.043 256.498 193.002C263.161 199.044 273.783 206.343 286.238 206.343C307.48 206.343 323.411 185.101 323.411 185.101C323.411 185.101 307.481 163.859 286.24 163.859Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.5 66.9026L260.888 80.4049H275.087L263.601 88.7532L267.985 102.256L256.5 93.9092L245.014 102.256L249.399 88.7532L237.913 80.4049H252.111L256.5 66.9026ZM202.507 90.5206L210.948 98.1205L220.785 92.4424L216.166 102.818L224.606 110.42L213.31 109.233L208.69 119.608L206.327 108.499L195.03 107.311L204.867 101.631L202.507 90.5206ZM162.979 130.047L174.091 132.409L179.77 122.572L180.959 133.868L192.069 136.231L181.692 140.85L182.88 152.146L175.278 143.706L164.901 148.325L170.581 138.488L162.979 130.047ZM310.494 90.5206L302.053 98.1205L292.215 92.4424L296.835 102.818L288.394 110.42L299.691 109.233L304.31 119.608L306.674 108.499L317.971 107.311L308.133 101.631L310.494 90.5206ZM350.02 130.047L338.909 132.409L333.229 122.572L332.041 133.868L320.931 136.231L331.309 140.85L330.121 152.146L337.722 143.706L348.099 148.325L342.419 138.488L350.02 130.047Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.5 265.821C273.373 265.821 288.926 260.191 301.404 250.719H211.599C224.074 260.191 239.627 265.821 256.5 265.821ZM188.344 221.212C190.694 226.579 193.671 231.648 197.212 236.315H315.788C319.329 231.648 322.305 226.579 324.655 221.212H188.344Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_722"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 342,
    fill: "white",
    transform: "translate(0 -0.00585938)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMo);
export default __webpack_public_path__ + "static/media/MO.b23be27039ea2469c4d2c394e0c17bfe.svg";
export { ForwardRef as ReactComponent };